import React, { useState, useEffect, useRef } from "react";
import Layouts from "../layouts/Layouts";
import { useLocation } from "react-router-dom";
import PageBanner from "../components/PageBanner";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from "react-i18next";

const BlogDetails = () => {
  const location = useLocation();
  const { blogItem } = location.state || {};
  const { t } = useTranslation();

  const [images, setImages] = useState([]);
  const [videos, setVideos] = useState([]);
  const postRef = useRef(null);

  const headerHeight = 60;

  useEffect(() => {
    if (blogItem && blogItem.images && blogItem.images.length > 0) {
      setImages(blogItem.images);
    } else {
      setImages([blogItem.imgSrc]);
    }

    if (blogItem && blogItem.videos && blogItem.videos.length > 0) {
      setVideos(blogItem.videos);
    }

    const timeoutId = setTimeout(() => {
      if (postRef.current) {
        window.scrollTo({
          top: postRef.current.offsetTop - headerHeight,
          behavior: "smooth",
        });
      }
    }, 1000);

    return () => clearTimeout(timeoutId);
  }, [blogItem]);

  if (!blogItem) {
    return <p>News item not found.</p>;
  }

  const formatDate = (date) => {
    if (date && date.seconds) {
      const fullDate = new Date(date.seconds * 1000);
      const options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      return fullDate.toLocaleDateString(undefined, options);
    }

    if (date instanceof Date) {
      const options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      return date.toLocaleDateString(undefined, options);
    }

    return "N/A";
  };

  const sliderSettings = {
    infinite: false,
    dots: true,
    arrows: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <Layouts footer={2} noheader>
      {/**
      <PageBanner
        title={t("pageBanner.blogDetails")}
        pageName={t("pageBanner.blogDetails")}
        pageNumber="8"
      />
     */}{" "}
      <section style={{ padding: "60px 0" }} ref={postRef}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "30px",
              padding: "20px",
            }}
          >
            <h1
              style={{
                fontSize: "2.5rem",
                color: "#34495e",
                marginBottom: "15px",
              }}
            >
              {blogItem.title}
            </h1>

            <div>
              <Slider {...sliderSettings}>
                {images.map((image, index) => (
                  <div key={index}>
                    <img
                      src={image}
                      alt={`image-${blogItem.title}`}
                      style={{
                        width: "100%",
                        height: "600px",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                ))}
                {videos.map((video, index) => (
                  <div key={index}>
                    <video
                      controls
                      style={{
                        width: "100%",
                        height: "600px",
                        objectFit: "cover",
                      }}
                    >
                      <source src={video} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </div>
                ))}
              </Slider>
            </div>

            <div
              style={{
                padding: "20px",
                backgroundColor: "#fff",
                border: "1px solid #ddd",
                borderRadius: "8px",
                boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
              }}
            >
              {/* Render the HTML content safely */}
              <div
                style={{
                  fontSize: "1.1rem",
                  color: "#7f8c8d",
                  marginBottom: "30px",
                }}
                dangerouslySetInnerHTML={{ __html: blogItem.description }}
              />
              <div
                style={{
                  fontSize: "1rem",
                  color: "#95a5a6",
                  marginBottom: "20px",
                }}
              >
                <strong>{formatDate(blogItem.createdAt)}</strong>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layouts>
  );
};

export default BlogDetails;
